"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchTabsPreview = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _search = require("../../../constants/search");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SearchTabsPreview = exports.SearchTabsPreview = function SearchTabsPreview(_ref) {
  var _ref$searchType = _ref.searchType,
    searchType = _ref$searchType === void 0 ? _search.SEARCH_TYPE_NAMES.PACKAGE : _ref$searchType,
    _onClick = _ref.onClick,
    availableSearchTypes = _ref.availableSearchTypes,
    isWhiteLabel = _ref.isWhiteLabel;
  var searchTypesArray = availableSearchTypes ? _search.SEARCH_TYPES.filter(function (_ref2) {
    var name = _ref2.name;
    return availableSearchTypes.includes(name);
  }) : _search.SEARCH_TYPES;
  return /*#__PURE__*/_react["default"].createElement(Tabs, null, searchTypesArray.map(function (_ref3) {
    var label = _ref3.label,
      name = _ref3.name;
    return /*#__PURE__*/_react["default"].createElement(Tab, {
      key: name,
      $isActive: name === searchType,
      $isWhiteLabel: isWhiteLabel,
      onClick: function onClick() {
        return _onClick === null || _onClick === void 0 ? void 0 : _onClick(name);
      }
    }, label);
  }));
};
var Tabs = _styledComponents["default"].div.withConfig({
  displayName: "SearchTabsPreview__Tabs",
  componentId: "sc-yuwy09-0"
})(["display:flex;margin-bottom:4px;"]);
var Tab = _styledComponents["default"].div.withConfig({
  displayName: "SearchTabsPreview__Tab",
  componentId: "sc-yuwy09-1"
})(["display:flex;border-radius:var(--border-radius);padding:4px 8px;cursor:pointer;font-size:12px;line-height:14px;", ""], function (_ref4) {
  var $isActive = _ref4.$isActive,
    $isWhiteLabel = _ref4.$isWhiteLabel;
  return $isActive ? (0, _styledComponents.css)(["background:var(--white);color:var(--secondary-header);"]) : $isWhiteLabel ? (0, _styledComponents.css)(["color:var(--primary-header-color);"]) : (0, _styledComponents.css)(["color:var(--black);"]);
});